import { clearQueueScrollLocks, enablePageScroll, getScrollState } from 'scroll-lock';

// Turbolinks клонирует <body> после turbolinks:before-cache, поэтому незакрытый скролл-лок
// (уход по ссылке из открытой модалки) попал бы в снимок и заблокировал скролл на
// restore-визите. Плюс очередь локов живёт в модуле и переживает навигацию: с ней уезжает
// и запрет touchmove, ломая тач-скролл уже на следующей странице.
$(document).on('turbolinks:before-cache', () => {
  if (getScrollState()) { return; }

  clearQueueScrollLocks();
  enablePageScroll();
});
